import { WebcareerscityMap } from "./webcareerscityAction";

const initialState = {
  isLoading: false,
  webcareerscityList: [],
  webcareerscitys: [],
  refreshWebcareerscity: true,
  selectedWebcareerscity: {},
  reDirect: false,
  searchBy: "",
  searchText: "",
  skip: 0,
  limit: 10,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case WebcareerscityMap.CREATE_WEB_CAREERS_CITY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case WebcareerscityMap.CREATE_WEB_CAREERS_CITY_SUCCESS: {
      return {
        ...state,
        refreshWebcareerscity: true,
        reDirect: true,
      };
    }
    case WebcareerscityMap.CREATE_WEB_CAREERS_CITY_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case WebcareerscityMap.GET_ALL_WEB_CAREERS_CITY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case WebcareerscityMap.GET_ALL_WEB_CAREERS_CITY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshWebcareerscity: false,
        webcareerscityList: action.payload,
      };
    }
    case WebcareerscityMap.GET_ALL_WEB_CAREERS_CITY_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshWebcareerscity: false,
      };
    }
    case WebcareerscityMap.UPDATE_WEB_CAREERS_CITY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case WebcareerscityMap.UPDATE_WEB_CAREERS_CITY_SUCCESS: {
      return {
        ...state,
        refreshWebcareerscity: true,
        selectedWebcareerscity: {
          ...state.selectedWebcareerscity,
          ...action.payload,
        },
        reDirect: true,
      };
    }
    case WebcareerscityMap.UPDATE_WEB_CAREERS_CITY_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case WebcareerscityMap.DELETE_WEB_CAREERS_CITY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case WebcareerscityMap.DELETE_WEB_CAREERS_CITY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshWebcareerscity: true,
      };
    }
    case WebcareerscityMap.DELETE_WEB_CAREERS_CITY_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case WebcareerscityMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }
    case WebcareerscityMap.REFRESH_WEB_CAREERS_CITY_LIST: {
      return {
        ...state,
        skip: 0,
        refreshWebcareerscity: true,
      };
    }
    case WebcareerscityMap.GET_WEB_CAREERS_CITY_DETAIL_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case WebcareerscityMap.GET_WEB_CAREERS_CITY_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        selectedWebcareerscity: action.payload,
        refreshWebcareerscity: false,
      };
    }
    case WebcareerscityMap.GET_WEB_CAREERS_CITY_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshWebcareerscity: false,
      };
    }
    case WebcareerscityMap.GET_WEB_CAREERS_CITY_LIST_START: {
      return {
        ...state,
      };
    }
    case WebcareerscityMap.GET_WEB_CAREERS_CITY_LIST_SUCCESS: {
      return {
        ...state,
        webcareerscitys: action.payload,
      };
    }
    case WebcareerscityMap.GET_WEB_CAREERS_CITY_LIST_ERROR: {
      return {
        ...state,
      };
    }
    case WebcareerscityMap.SET_WEB_CAREERS_CITY_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshWebcareerscity: true,
      };
    }
    default:
      return { ...state };
  }
};
